import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=2929ee9e&scoped=true&"
import script from "./AddressBlock.vue?vue&type=script&lang=ts&"
export * from "./AddressBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AddressBlock.vue?vue&type=style&index=0&id=2929ee9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929ee9e",
  null
  
)

export default component.exports